import Error500Page from './Error500Page';
import { authModules } from 'app/auth';

const Error500PageConfig = {
	settings: {
		layout: {
			config: {
				navbar: {
					display: false
				},
				toolbar: {
					display: false
				},
				footer: {
					display: false
				},
				leftSidePanel: {
					display: false
				},
				rightSidePanel: {
					display: false
				}
			}
		}
	},
	auth: authModules.openforall,
	routes: [
		{
			path: '/error500',
			element: <Error500Page />
		}
	]
};

export default Error500PageConfig;
